export default (min = 10000, max = 99999) => {
  return Math.ceil(Math.random() * (max - min) + min)
}
